<template lang='pug'>
//- 每日健康促進
div(:class='$style[`cc-popbox-checklist`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  .font-medium(:class='$style[`cc-checklist-wrap-block-category`]') {{ detail.category }}
  div(:class='$style[`cc-popbox-checklist-thumb`]')
    figure.checklist-icon-exercise(v-if='detail.category === "運動健身"')
    figure.checklist-icon-food(v-else-if='detail.category === "營養飲食"')
    figure.checklist-icon-outdoor(v-else-if='detail.category === "戶外活動"')
    figure.checklist-icon-life(v-else-if='detail.category === "生活保健"')

  div(:class='$style[`cc-checklist-wrap`]')
    div(:class='$style[`cc-checklist-wrap-block`]')
      .font-bold(:class='$style[`cc-checklist-wrap-block-title`]') {{ detail.content }}
      .font-medium(:class='$style[`cc-checklist-wrap-block-tips`]')
        svg(fill="none" viewBox="0 0 24 24" height="20" width="20")
          circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
        != '{{ detail.create_date }} 達成目標'

    div(:class='$style[`cc-content-checklist-controller`]')
      button.btn-extra.font-medium(
        aria-label='關閉'
        tabindex='0'
        :class='$style[`cc-checklist-controller-btn`]'
        @click='handleClosePopBox') 關閉

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import IconIdeas from '../../icon/Ideas.vue';
import IconLoading from '../../icon/Loading';

// import {
//   putLoadGoldKnowLedge,
// } from '../../../js/restapi';

export default {
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },

  components: {
    IconIdeas,
    IconLoading,
  },

  data() {
    return {
      preloading: true,
      // current: {
      //   content: '',
      //   category: ''
      // }
    };
  },

  methods: {
    ...mapMutations({
      changePopCheckListStatus: 'global/POPCHECKLIST_STATUS',
    }),

    handleClosePopBox() {
      this.changePopCheckListStatus({
        active: false,
        detail: {},
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),

    // randomContent() {
    //   const index = Math.floor(Math.random() * (this.dataTotal));
    //   const getContent = this.dataList[index];
    //   return getContent;
    // },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popHealthCheckList.scss';
</style>
